import React from "react";
import point from "./assets/images/point.svg";
import { makeStyles } from "@material-ui/core/styles";
import styles from "./assets/styles/popover.styles";
import CloseIcon from "@material-ui/icons/Close";
import Fade from "@material-ui/core/Fade";
import Popper from "@material-ui/core/Popper";
import { useMediaQuery } from "@material-ui/core";
import { useState, useEffect } from "react";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

const useStyles = makeStyles(styles);

export default function PopoverElem({
  x,
  y,
  title,
  content,
  open,
  name,
  img,
  handleClose,
  handleOpen,
  anchorEl,
}) {
  const props = { x, y };
  const isMobile = useMediaQuery("(max-width: 1000px)");
  const boundaries = isMobile ? "viewport" : "parent";
  const classes = useStyles(props);
  const [stateOpen, setState] = useState(false);
  useEffect(() => {
    if (!stateOpen) handleClose(name);
  }, [stateOpen]);
  return (
    <span className={classes.wrapper}>
      <ClickAwayListener
        onClickAway={() => {
          stateOpen ? setState(false) : setState(true);
        }}
      >
        <Popper
          open={open}
          anchorEl={anchorEl}
          style={{ zIndex: 100 }}
          modifiers={{
            offset: {
              enabled: true,
              offset: "0, -62",
            },
            preventOverflow: {
              enabled: true,
              boundariesElement: boundaries,
            },
          }}
          placement="left-start"
          transition
        >
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
              <div className={classes.root}>
                <CloseIcon
                  style={{ zIndex: 99 }}
                  className={classes.closeIcon}
                  onClick={() => {
                    handleClose(name);
                    setState(false);
                  }}
                />
                <img className={classes.cover} alt="details" src={img} />
                <strong className={classes.title}>{title}</strong>
                <p className={classes.content}>{content}</p>
              </div>
            </Fade>
          )}
        </Popper>
      </ClickAwayListener>
      <img
        alt="open popover"
        onClick={(e) => handleOpen(e, name)}
        src={point}
        className={classes.point}
      />
    </span>
  );
}

// const useStyles = makeStyles(styles)

// export default function PopoverElem({ x, y, content, open, name, img, handleClose, handleOpen }) {
//     const props = { x, y, open }
//     const classes = useStyles(props)
//     return (
//         <div className={classes.wrapper} >
//             {open ?
//                 <div className={classes.root} >
//                     <CloseIcon className={classes.closeIcon} onClick={() => handleClose(name)} />
//                     <img className={classes.cover} alt='details' src={img} />
//                     <p className={classes.content} >{content}</p>
//                 </div> :
//                 <img alt='open popover' onClick={e => handleOpen(name)} src={point} className={classes.point} />
//             }
//         </div>
//     )
// }
